import { render, staticRenderFns } from "./DigitalFluVoucherReminderNoCode.vue?vue&type=template&id=883bff56&scoped=true&"
import script from "./DigitalFluVoucherReminderNoCode.vue?vue&type=script&lang=js&"
export * from "./DigitalFluVoucherReminderNoCode.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFluVoucherReminderNoCode.vue?vue&type=style&index=0&id=883bff56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883bff56",
  null
  
)

export default component.exports